import React, { useContext, useEffect, useState } from 'react'
import { UserContext } from '../../context/UserContext'
import { Form, Col,  } from 'react-bootstrap'
import { Dropdown } from 'primereact/dropdown'
import css from '../AnuncioForm.module.css'
import { linkApi } from '../../config'

export default function Segments({ values, setFieldValue }) {
    const { user } = useContext(UserContext)
    const [segment, setSegment] = useState([])

    const handleDropdownChange = (e) => {
        setFieldValue('segment.id', e.target.value)
        setFieldValue('engine.power_cv', '')
        setFieldValue('version.id', '')
    }

    useEffect(() => {
        let model = values.model.id
        let years = values.registration.year
        let fuel = values.fuel.id

        const getData = async () => {
            const options = {
                method: 'GET',
                headers: {
                    authorization: 'Bearer ' + user.token,
                },
            }

            const res = await fetch(
                `${linkApi}/v1/cars/segments/${model}/?ano=${years}&fuel=${fuel}`,
                options
            )
                .then((response) => response.json())
                .catch((err) => console.error(err))

            setSegment(res.data)
        }
        getData()
    }, [user.token, values.model.id, values.registration.year, values.fuel.id])

    return (
        <div>
            <Form.Group as={Col} controlId="validationFormik04">
                <Form.Label className={css.label}>Segmentos</Form.Label>
                <Dropdown
                    value={values.segment.id}
                    onChange={handleDropdownChange}
                    options={segment}
                    placeholder="Escolher"
                    optionLabel="name"
                    optionValue="id"
                    filter
                    className="w-full md:w-14rem"
                    style={{ width: '-webkit-fill-available' }}
                />
            </Form.Group>
        </div>
    )
}
